var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "30", height: "30", viewBox: "0 0 30 30", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    React.createElement(
      "defs",
      null,
      React.createElement("path", { id: "close-x", d: "M23 9.139L20.861 7 15.5 12.361 10.139 7 8 9.139l5.361 5.361L8 19.861 10.139 22l5.361-5.361L20.861 22 23 19.861 17.639 14.5z" })
    ),
    React.createElement("use", { fill: "#FA8575", xlinkHref: "#close-x", fillRule: "evenodd" })
  );
});


// WEBPACK FOOTER //
// ./src/shared/components/svgs/close_x.svg